import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { NOTIFICATION_STATUS_MAP } from '@returnmates/client-core/src/constants/notification'
import { Notification } from '@returnmates/client-core/src/graphql/generated/api'
import { NotificationStatus } from '@returnmates/client-core/src/graphql/generatedNotifications/api'
import clsx from 'clsx'
import moment from 'moment-timezone'
import { memo } from 'react'

import useStyles from '../styles'

interface Props {
  notification: Notification
}

function NotificationTrackingRow({ notification }: Props): JSX.Element {
  const classes = useStyles()

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={clsx(classes.bodyCell, classes.noWrapText)}>
        <p>
          {moment
            .unix(notification.createdAt)
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format('M/D/YY h:mm A z')}
        </p>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <p>{NOTIFICATION_STATUS_MAP[notification.status as NotificationStatus]}</p>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <p>{notification?.templateName ? notification.templateName.replaceAll('_', ' ') : ''}</p>
      </TableCell>
    </TableRow>
  )
}

export default memo(NotificationTrackingRow)
